export default __webpack_public_path__ + "static/media/add-user.a8955924.png";